import { render } from "./EnviarNominas.vue?vue&type=template&id=6db559b2&scoped=true"
import script from "./EnviarNominas.vue?vue&type=script&lang=js"
export * from "./EnviarNominas.vue?vue&type=script&lang=js"

import "./EnviarNominas.vue?vue&type=style&index=0&id=6db559b2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db559b2"]])

export default __exports__